import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import "./PSAResponseProbability.scss";

function PSAResponseProbability({ predictions, nonResponser = false }) {
  const logisticPSA50PercentDeclinePercentage = Math.round(predictions.logisticPSA50PercentDecline * 100);

  return (
    <div className="PSAResponseProbability">
      <ReactTooltip place="top" effect="solid" />
      <div className="row">
        <div className="col-md-auto">
          <h4 data-tip="PSA response was defined as a reduction of 50% or more from baseline at any time during treatment">
            Probability of PSA Response
          </h4>
        </div>
        <div className="col">
          <div className="row">
            <div className="col">
              <div className="progress bg-white">
                <div
                  className="progress-bar bg-light-grey"
                  role="progressbar"
                  style={{
                    width: `${logisticPSA50PercentDeclinePercentage}%`,
                  }}
                  aria-valuenow={logisticPSA50PercentDeclinePercentage}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <h5 className="dark-grey">{logisticPSA50PercentDeclinePercentage}%</h5>
                </div>
                {nonResponser && (
                  <div
                    className="progress-bar bg-white"
                    role="progressbar"
                    style={{
                      width: `${100 - logisticPSA50PercentDeclinePercentage}%`,
                    }}
                    aria-valuenow={100 - logisticPSA50PercentDeclinePercentage}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <h5 className="red">Likely non-responder</h5>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Previous implementation
  //   return (
  //     <div className="row">
  //       <div className="col-lg-4 col-md-5" style={{ marginTop: "0.5em" }}>
  //         <h4 className="text-center">PSA Response Probability</h4>
  //       </div>
  //       <div className="col-lg-8 col-md-7">
  //         <div className="row">
  //           <div className="col-4">
  //             <h5 className="text-center" style={{ marginTop: "0.05em", marginBottom: "0.25em", color: "#333" }}>
  //               {Math.round(predictions.logisticPSA50PercentDecline * 100)}%
  //             </h5>
  //           </div>
  //           <div className="col-8">
  //             <h5 className="text-center" style={{ marginTop: "0.05em", marginBottom: "0.25em", color: "#960005" }}>
  //               Likely non-responder
  //             </h5>
  //           </div>
  //         </div>
  //         <div className="row">
  //           <div className="col">
  //             <div className="progress" style={{ height: "4px" }}>
  //               <div
  //                 class="progress-bar"
  //                 role="progressbar"
  //                 style={{ width: `${Math.round(predictions.logisticPSA50PercentDecline * 100)}%` }}
  //                 aria-valuenow={Math.round(predictions.logisticPSA50PercentDecline * 100)}
  //                 aria-valuemin="0"
  //                 aria-valuemax="100"
  //               ></div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
}

PSAResponseProbability.propTypes = {
  predictions: PropTypes.shape({
    logisticPSA50PercentDecline: PropTypes.number.isRequired,
  }),
  nonResponser: PropTypes.bool,
};

export default PSAResponseProbability;
